"use client";
import * as prismic from "@prismicio/client";
import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";

// const testimonials = [
//   {
//     text: "The cake Georgiana made completely blew us away! It was hard to believe something so beautifully presented could taste so light and delicious. She is incredibly talented and I would highly recommend her for any occasion that calls for cake!",
//     author: "Mary",
//   },
//   {
//     text: "Absolutely stunning cake, both in looks and taste! Georgiana is a true artist, and her cakes are the highlight of any celebration.",
//     author: "John",
//   },
//   {
//     text: "I have never had a cake this delicious. Light, flavorful, and simply gorgeous. Highly recommended!",
//     author: "Sophia",
//   },
// ];

export default function TestimonialsCarousel({ slice }) {
  const testimonials = slice.primary.items;
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <section
      id={slice.primary.anchor || undefined}
      aria-label="Sweet words from my customers"
      className="bg-[#f6f0ef] mx-auto my-0"
    >
      <div className="flex relative items-center justify-center py-20 md:py-32 p-6">
        <div className="relative w-full max-w-4xl text-center">
          <span className="absolute -top-[85px] left-0 text-8xl text-white font-serif">
            &ldquo;
          </span>
          <p className="text-3xl md:text-5xl font-serif text-gray-700">
            {prismic.asText(slice.primary.title)}
          </p>
          <div className="mt-20 text-lg text-gray-600 relative px-10 flex items-center justify-center h-[200px]">
            <p className="font-serif text-base md:text-2xl inline-block mx-8 leading-relaxed">
              {prismic.asText(testimonials[currentIndex].quote)}
            </p>
          </div>
          <p className="mt-10 md:mt-4 font-normal text-gray-600 text-right pr-10 uppercase leading-relaxed">
            {prismic.asText(testimonials[currentIndex].author)}
          </p>
          <div
            className="absolute top-[60%] left-4 -translate-y-1/2 cursor-pointer"
            onClick={prevTestimonial}
          >
            <Icon icon="fluent:chevron-left-32-regular" className="w-6 h-6" />
          </div>
          <div
            className="absolute top-[60%] right-4 -translate-y-1/2 cursor-pointer"
            onClick={nextTestimonial}
          >
            <Icon icon="fluent:chevron-right-32-regular" className="w-6 h-6" />
          </div>
          <span className="absolute -bottom-[120px] right-0 text-8xl text-white font-serif">
            &rdquo;
          </span>
        </div>
      </div>
    </section>
  );
}
